export const junkMailHeader = "uuNQ5d";
export const singleItem = "zZyHN";
export const noneOrMultipleItems = "PYXhSc";
export const recoverItemsDeletedFromThisFolder = "ffqBRe";
export const goBackToDeletedItems = "RzRvdd";
export const deletedItemsFolderWarning = "j9zKXb";
export const attachmentsSearchFolderWarning = "ynAKAd";
export const unsyncedFolderWarning = "FkwGWc";
export default {junkMailHeader,singleItem,noneOrMultipleItems,recoverItemsDeletedFromThisFolder,goBackToDeletedItems,deletedItemsFolderWarning,attachmentsSearchFolderWarning,unsyncedFolderWarning};